import { withInstall } from '@xzx-design/utils'
import _PullRefresh from './src/pull-refresh'

export const PullRefresh = withInstall(_PullRefresh)
export default PullRefresh

export * from './src/pull-refresh'
export * from './src/types'
